import HandOut from './hand_out';

export default HandOut;
